import {
  RECEIVE_TEAMS,
  ADD_SESSION,
  DELETE_SESSION,
  ADD_TEAM,
  SET_ACTIVE_TEAM
} from '../mutation-types'

// initial state
const state = {
  all: [],
  active: {},
  sessions: []
}

// mutations
const mutations = {
  [RECEIVE_TEAMS] (state, teams) {
    state.all = teams
  },
  [ADD_SESSION] (state) {
    state.sessions.push({
      id: 4,
      exercises: []
    })
  },
  [DELETE_SESSION] (state, id) {
    console.log(id)
    state.sessions.splice(id, 1)
  },
  [ADD_TEAM] (state, team) {
    console.log('team', team)
    if (state.all.length > 0) {
      state.all.unshift(team.data)
    }
  },
  [SET_ACTIVE_TEAM] (state, id) {
    const active = state.all.find(team => team.id === parseInt(id))
    state.active = active
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/teams/store.js